<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <!-- Pendente Assinatura -->
      <div class="col-md-4">
        <b-card>
          <b-card-title>
            Pendente Assinatura -# {{ pendentes.length }}
          </b-card-title>
          <div v-for="(pendente, index) in pendentes" :key="index">
            <b-card class="div-clickable" @click="abreModal(pendente)">
              <div>
                <h5 class="font-size-15 text-secondary">
                  {{ pendente.ds_nome }}
                </h5>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-muted text-start">
                  <i class="mdi mdi-email"></i> {{ pendente.ds_email }}</span
                >
                <span>
                  <i class="mdi mdi-calendar"></i>
                  {{ $tools.converteData(pendente.dt_documento) }}</span
                >
              </div>
            </b-card>
          </div>
        </b-card>
      </div>
      <!-- Assinados -->
      <div class="col-md-4">
        <b-card>
          <b-card-title> Assinados -# {{ assinados.length }} </b-card-title>
          <div v-for="(assinado, index) in assinados" :key="index">
            <b-card>
              <div>
                <h5 class="font-size-15 text-secondary">
                  {{ assinado.ds_nome }}
                </h5>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-muted text-start">
                  <i class="mdi mdi-email"></i> {{ assinado.ds_email }}</span
                >
                <span>
                  <i class="mdi mdi-calendar"></i>
                  {{ $tools.converteData(assinado.dt_documento) }}</span
                >
              </div>
            </b-card>
          </div>
        </b-card>
      </div>
      <!-- Cancelados -->
      <div class="col-md-4">
        <b-card>
          <b-card-title> Cancelados -# {{ cancelados.length }} </b-card-title>
          <div v-for="(cancelado, index) in cancelados" :key="index">
            <b-card>
              <div>
                <h5 class="font-size-15 text-secondary">
                  {{ cancelado.ds_nome }}
                </h5>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-muted text-start">
                  <i class="mdi mdi-email"></i> {{ cancelado.ds_email }}</span
                >
                <span>
                  <i class="mdi mdi-calendar"></i>
                  {{ $tools.converteData(cancelado.dt_documento) }}</span
                >
              </div>
            </b-card>
          </div>
        </b-card>
      </div>
    </div>

    <b-modal title="Contrato" v-model="modalShow">
      {{ dadosModal }}
    </b-modal>
  </div>
</template>
<script>
import PageHeader from "@/components/page-header";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      title: "Assinatura Eletrônica de Documentos",
      items: [
        {
          text: "Assinatura Eletrônica de Documento",
        },
      ],
      pendentes: [
        {
          ds_nome: "ADRIANO MALTEZO DA ROCH",
          cd_documento: "98950",
          ds_email: "teste@gmail.com",
          dt_documento: "2022-01-12 00:00:00",
        },
        {
          ds_nome: "AMAURI WREGE GONÇALVES",
          cd_documento: "98632",
          ds_email: "teste@gmail.com",
          dt_documento: "2022-12-01 00:00:00",
        },
        {
          ds_nome: "BRUNO SACCO NOGUEIRA",
          cd_documento: "99212",
          ds_email: "teste@gmail.com",
          dt_documento: "2022-05-09 00:00:00",
        },
        {
          ds_nome: "CLEITON NASCIMENTO LEAL",
          cd_documento: "99059",
          ds_email: "teste@gmail.com",
          dt_documento: "2022-03-04 00:00:00",
        },
      ],
      assinados: [
        {
          ds_nome: "ADRIANA BORGES DA SILBA",
          cd_documento: "96964",
          ds_email: "teste@gmail.com",
          dt_documento: "2022-01-12 00:00:00",
        },
        {
          ds_nome: "ADRIANO ALVIM ROCHA",
          cd_documento: "97766",
          ds_email: "teste@gmail.com",
          dt_documento: "2022-12-01 00:00:00",
        },
        {
          ds_nome: "ADRIANO CARVALHO DA ROCHA",
          cd_documento: "97526",
          ds_email: "teste@gmail.com",
          dt_documento: "2022-05-09 00:00:00",
        },
      ],
      cancelados: [],
      dadosModal: [],
      modalShow: false,
    };
  },
  methods: {
    abreModal(contrato) {
      this.dadosModal = [];
      this.dadosModal = contrato;
      this.modalShow = true;
    },
  },
};
</script>